// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kakaomap_markerbox__7OMp2 {
  width: 400px;
}
.kakaomap_text-box__jceso {
  padding: 0%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height : 80px;
  width : 200px;
  background-color: white;
  font-size: 23px;
}

.kakaomap_text-link__6xyZR {
  font-size: 20px;
  color: gray
}


/* 화면이 좁을 때: 4행 × 2열 */
@media (max-width: 1024px) {
  
  .kakaomap_text-box__jceso {
    height : 50px;
    font-size: 16px;
    width : 150px;
  }

  .kakaomap_text-link__6xyZR {
    font-size: 10px;
  }
 
}`, "",{"version":3,"sources":["webpack://./src/kakaomap.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf;AACF;;;AAGA,sBAAsB;AACtB;;EAEE;IACE,aAAa;IACb,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":[".markerbox {\n  width: 400px;\n}\n.text-box {\n  padding: 0%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height : 80px;\n  width : 200px;\n  background-color: white;\n  font-size: 23px;\n}\n\n.text-link {\n  font-size: 20px;\n  color: gray\n}\n\n\n/* 화면이 좁을 때: 4행 × 2열 */\n@media (max-width: 1024px) {\n  \n  .text-box {\n    height : 50px;\n    font-size: 16px;\n    width : 150px;\n  }\n\n  .text-link {\n    font-size: 10px;\n  }\n \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"markerbox": `kakaomap_markerbox__7OMp2`,
	"text-box": `kakaomap_text-box__jceso`,
	"text-link": `kakaomap_text-link__6xyZR`
};
export default ___CSS_LOADER_EXPORT___;
